import intlTelInput from 'intl-tel-input';
import 'intl-tel-input/build/css/intlTelInput.css';

jQuery(function ($) {
    const phoneInputIDs = ["#billing_phone", "#shipping_phone"];
    const itiMap = new WeakMap();
    const lastRawNumberMap = new WeakMap();

    function initPhoneInput(selector) {
        const input = document.querySelector(selector);

        if (!input || input.classList.contains("iti-loaded")) {
            return;
        }

        input.classList.add("iti-loaded");

        const iti = intlTelInput(input, {
            initialCountry: spraga_obj.default_country || "auto",
            separateDialCode: true,
            strictMode: true,
            // hiddenInput removed — it renames the visible input's `name` attribute,
            // which breaks WooCommerce form submission (WC can't find shipping_phone).
            // Instead, writeFullPhoneNumbers() writes the full E.164 number before submit.
            customPlaceholder: (selectedCountryPlaceholder, selectedCountryData) => {
                if (!selectedCountryPlaceholder) return "";
                let placeholder = selectedCountryPlaceholder;

                if (selectedCountryData.iso2 === 'bg' && placeholder.startsWith('0')) {
                    placeholder = placeholder.substring(1).trim();
                }
                return "e.g. " + placeholder;
            },
            geoIpLookup: function (callback) {
                fetch("https://ipapi.co/json")
                    .then((res) => res.json())
                    .then((data) => callback(data.country_code))
                    .catch(() => callback("bg"));
            },
            loadUtils: () => import("intl-tel-input/utils"),
        });

        itiMap.set(input, iti);
        lastRawNumberMap.set(input, "");

        input.addEventListener('input', function () {
            const itiInstance = itiMap.get(input);
            if (!itiInstance) return;

            const countryData = itiInstance.getSelectedCountryData();
            const dialCode = countryData.dialCode;

            let val = input.value;

            if (val.startsWith('+' + dialCode)) {
                val = val.substring(dialCode.length + 1).trim();
            } else if (val.startsWith(dialCode)) {
                val = val.substring(dialCode.length).trim();
            }

            input.value = val.replace(/[^\d\s-]/g, '');
            lastRawNumberMap.set(input, val);
        });

        const updateMaxLength = () => {
            const placeholder = input.getAttribute("placeholder") || "88 123 4567";
            const len = placeholder.replace(/\D/g, '').length + 4;
            input.setAttribute("maxlength", len);
        };

        input.addEventListener('countrychange', updateMaxLength);
        setTimeout(updateMaxLength, 1000);
    }

    function initAllPhoneInputs() {
        phoneInputIDs.forEach((selector) => initPhoneInput(selector));
    }

    // ITI requires the input to be visible during initialization.
    // For guests, #customer_details is hidden — so we temporarily make it
    // visible (invisible to user via opacity) to allow ITI to init correctly.
    const $details = $('#customer_details');
    const wasHidden = !$details.is(':visible');

    if (wasHidden) {
        $details.css({ visibility: 'hidden', display: 'block' });
    }

    initAllPhoneInputs();

    if (wasHidden) {
        $details.css({ visibility: '', display: 'none' });
    }

    toggleBillingFields();

    $(document.body).on('updated_checkout', () => {
        initAllPhoneInputs();
        toggleBillingFields();
    });


    function forceShipToDifferentAddress() {
        let $f = $('#ship_to_different_address');

        if (!$f.length) {
            $('form.checkout').append('<input type="hidden" name="ship_to_different_address" id="ship_to_different_address" value="1" />');
        } else {
            $f.val('1');
        }
    }


    /**
     * Custom checkbox:
     * - checkbox name/id: spraga_billing_same
     * - when checked (same=1) => HIDE billing fields + fill billing from shipping
     * - when unchecked (same=0) => SHOW billing fields + restore billing defaults
     */
    function toggleBillingFields() {
        const $cb = $('#spraga_billing_same');
        const isSame = $cb.length ? $cb.is(':checked') : true; // default same=true

        const $wrap = $('#billing_fields_wrap');
        if (!$wrap.length) return;

        const ids = [
            '#billing_first_name',
            '#billing_last_name',
            '#billing_address_1',
            '#billing_city',
            '#billing_postcode',
            '#billing_phone',
            '#b2bking_custom_field_1951'
        ];

        if (!isSame) {
            // When opening billing fields, restore saved billing defaults for a clean UX
            restoreBillingDefaults();
            $wrap.stop(true, true).slideDown(150);
        } else {
            // When billing is SAME as shipping, keep billing fields hidden,
            // but make sure billing values match what user entered in shipping.
            copyShippingToBilling();
            $wrap.stop(true, true).slideUp(150);
        }

        // Required/validation classes follow "DIFF" state
        ids.forEach((sel) => {
            const $f = $(sel);
            if (!$f.length) return;

            $f.prop('required', !isSame);

            const $fieldWrap = $(sel + '_field');
            if ($fieldWrap.length) {
                $fieldWrap.toggleClass('validate-required', !isSame);
                $fieldWrap.toggleClass('woocommerce-validated', false);
                $fieldWrap.toggleClass('woocommerce-invalid', false);
            }
        });

        if (isSame) {
            copyShippingToBilling();
        }
    }

    function copyShippingToBilling() {
        const fields = ['first_name', 'last_name', 'address_1', 'address_2', 'city', 'postcode', 'phone'];
        fields.forEach(f => {
            const $s = $(`#shipping_${f}`);
            const $b = $(`#billing_${f}`);
            if ($s.length && $b.length) {
                const val = ($s.val() || '').toString().trim();
                if ($b.val() !== val) {
                    $b.val(val).trigger('change');
                }
            }
        });

        // Also sync hidden country/state
        const sc = $('#shipping_country').val();
        const bc = $('#billing_country').val();
        if (sc && bc !== sc) {
            $('#billing_country').val(sc).trigger('change');
        }

        const ss = $('#shipping_state').val();
        const bs = $('#billing_state').val();
        if (ss !== undefined && bs !== ss) {
            $('#billing_state').val(ss).trigger('change');
        }
    }


    /**
     * Restore billing fields to their saved account defaults (data-default attribute).
     * Called when user unchecks "Same as shipping address".
     */
    function restoreBillingDefaults() {
        const fields = ['#billing_first_name', '#billing_last_name', '#billing_address_1', '#billing_city', '#billing_postcode'];
        fields.forEach((sel) => {
            const $f = $(sel);
            if (!$f.length) return;
            const def = $f.data('default');
            if (def !== undefined && def !== '') {
                $f.val(def);
            }
        });
    }
    /**
     * Before submit:
     * - If billing is NOT different => enforce shipping -> billing (hidden billing fields)
     * - If billing is different => do nothing (user's billing fields will be used)
     */
    function prepareBillingFieldsForSubmit() {
        const isSame = $('#spraga_billing_same').is(':checked');
        if (isSame) {
            copyShippingToBilling();
        }
    }

    // Initial state on load
    toggleBillingFields();

    // Toggle on checkbox change
    $(document).on('change', '#spraga_billing_same', function () {
        toggleBillingFields();
        forceShipToDifferentAddress();
    });

    /**
     * Before submit: write the full international number (e.g. +447911123456)
     * directly into the visible shipping_phone / billing_phone inputs.
     * WooCommerce reads these fields by name on form submission.
     */
    function writeFullPhoneNumbers() {
        phoneInputIDs.forEach((selector) => {
            const input = document.querySelector(selector);
            if (!input) return;
            const iti = itiMap.get(input);
            if (!iti) return;
            const full = iti.getNumber(); // E.164 format, e.g. +447911123456
            if (full) {
                input.value = full;
            }
        });
    }

    // Just before placing order (Woo AJAX event)
    $(document.body).on('checkout_place_order', function () {
        writeFullPhoneNumbers();
        forceShipToDifferentAddress();
        prepareBillingFieldsForSubmit();
        return true;
    });

    // Fallback (non-AJAX submit)
    $(document).on('submit', 'form.checkout', function () {
        writeFullPhoneNumbers();
        forceShipToDifferentAddress();
        prepareBillingFieldsForSubmit();
    });
});
